import { create } from 'zustand'

/**
 * Чисто интерфейсное состояние (zustand — только для него, серверные данные
 * живут в TanStack Query).
 */

export type BotsViewMode = 'grid' | 'table'
export type LogLevelFilter = 'all' | 'chat' | 'warn'

interface UiState {
  /** Drawer навигации на мобиле (docs/10 §2). */
  navOpen: boolean
  /** Сайдбар свёрнут в иконки — 1024–1279px и по желанию (docs/10 §7). */
  sidebarCollapsed: boolean
  /** Сетка или компактная таблица при >24 ботах (docs/10 §3.1). */
  botsView: BotsViewMode
  /** Фильтр уровня в консоли логов. */
  logFilter: LogLevelFilter
  logSearch: string
  /** Шпаргалка горячих клавиш (`?`). */
  shortcutsOpen: boolean
  /** Подтверждение серверной команды показываем один раз за сессию (docs/10 §3.2). */
  serverCommandConfirmed: boolean
  setNavOpen: (open: boolean) => void
  toggleSidebar: () => void
  setBotsView: (view: BotsViewMode) => void
  setLogFilter: (filter: LogLevelFilter) => void
  setLogSearch: (search: string) => void
  setShortcutsOpen: (open: boolean) => void
  markServerCommandConfirmed: () => void
}

export const useUiStore = create<UiState>(set => ({
  navOpen: false,
  sidebarCollapsed: false,
  botsView: 'grid',
  logFilter: 'all',
  logSearch: '',
  shortcutsOpen: false,
  serverCommandConfirmed: false,
  setNavOpen: navOpen => set({ navOpen }),
  toggleSidebar: () => set(state => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setBotsView: botsView => set({ botsView }),
  setLogFilter: logFilter => set({ logFilter }),
  setLogSearch: logSearch => set({ logSearch }),
  setShortcutsOpen: shortcutsOpen => set({ shortcutsOpen }),
  markServerCommandConfirmed: () => set({ serverCommandConfirmed: true })
}))
